'use strict';

import dwUtils from '../util';
import * as Utils from '../helpers/born.utils';
import {breakpoints, toggleOverlay, isMobile} from '../helpers/born.utils';
import TrackingLayer from '../modules/module.tracking-layer';
import dwValidator from '../validator';

var progress = require('../progress');

var SIGNUP_DETAILS = '.js-brandcampaign-signup';

let $signupBlock = $(SIGNUP_DETAILS),
    $form = $signupBlock.find('form');

function addSignupHandler() {
    let subFormSettings = $.extend(true, {submitHandler: sendSignupRequest}, dwValidator.settings),
        ref = $form.find('[name$=ref]').val();

    dwValidator.initForm($form, subFormSettings);
 
    let page = {
        type:"Campaign", 
        breadcrumb: ['Home', 'Campaign', 'Alamodist']
    };

    if(ref && ref != 'stringEmpty') { 
        page.page_ref = ref; 
    }

    TrackingLayer.pushData(page, 'page');

}

function sendSignupRequest() {
    progress.show($(SIGNUP_DETAILS));
    $.ajax({
        url: dwUtils.ajaxUrl($form.attr('action')),
        data: $form.serialize(),
        complete: function(response) {
            showConfirmationScreen();
            TrackingLayer.pushData('mail_signup: ' + window.Resources['BRAND_SIGNUP']);
        }
    });

    return false;
}

function showConfirmationScreen() {
    var $signupBlock = $form.parents().find('.js-brandcampaign-signup');

    if (SitePreferences.BRANDSIGNUP_CONFIRMATION_COLOR) {
        $signupBlock.css('color', '#' + SitePreferences.BRANDSIGNUP_CONFIRMATION_COLOR);
    }

    $signupBlock.html(SitePreferences.BRANDSIGNUP_CONFIRMATION);

    if (dwUtils.isMobile()) {
        window.scrollTo(0, ($signupBlock.offset().top - $('.header__main').height()));
    }

    progress.hide();
}

function initEventHandlers() {
	addSignupHandler();
};

exports.init = function () {
    initEventHandlers();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/brandcampaign.js